// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aiiif-splitter {
    background: #d7d6d7;
    z-index: 999;
}

.aiiif-splitter-dots {
    width: 100%;
    margin: auto 0;
}

.aiiif-splitter-dots > div {
    display: flex;
}

.aiiif-splitter-dots > div > div {
    background: white;
    width: 2px;
    height: 2px;
    margin: 1px auto;
}


.aiiif-splitter-horizontal > div > .aiiif-splitter-dots {
    height: 100%;
    width: inherit;
    margin: auto;
}

.aiiif-splitter-horizontal > div > .aiiif-splitter-dots > div > div {
    margin: 1px;
}

.aiiif-splitter-vertical > .aiiif-splitter {
    cursor: col-resize;
    min-width: 8px;
}

.aiiif-splitter-horizontal > .aiiif-splitter {
    min-height: 8px;
    cursor: row-resize;
}


.aiiif-splitter:hover {
    background-color: black;
}

body.no-select {
    user-select: none;
}

.aiiif-splitter-container {
    display: flex;
    flex-grow: 2;
    overflow: hidden;
}

.aiiif-splitter-horizontal {
    flex-direction: column;
    height: 100%;
}

.aiiif-splitter-container > div {
    display: flex;
    align-items: stretch;
}

.aiiif-splitter-container > div.aiiif-b {
    flex-grow: 2;
}

`, "",{"version":3,"sources":["webpack://./src/splitter/splitter.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB;;;AAGA;IACI,YAAY;IACZ,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;;AAGA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".aiiif-splitter {\n    background: #d7d6d7;\n    z-index: 999;\n}\n\n.aiiif-splitter-dots {\n    width: 100%;\n    margin: auto 0;\n}\n\n.aiiif-splitter-dots > div {\n    display: flex;\n}\n\n.aiiif-splitter-dots > div > div {\n    background: white;\n    width: 2px;\n    height: 2px;\n    margin: 1px auto;\n}\n\n\n.aiiif-splitter-horizontal > div > .aiiif-splitter-dots {\n    height: 100%;\n    width: inherit;\n    margin: auto;\n}\n\n.aiiif-splitter-horizontal > div > .aiiif-splitter-dots > div > div {\n    margin: 1px;\n}\n\n.aiiif-splitter-vertical > .aiiif-splitter {\n    cursor: col-resize;\n    min-width: 8px;\n}\n\n.aiiif-splitter-horizontal > .aiiif-splitter {\n    min-height: 8px;\n    cursor: row-resize;\n}\n\n\n.aiiif-splitter:hover {\n    background-color: black;\n}\n\nbody.no-select {\n    user-select: none;\n}\n\n.aiiif-splitter-container {\n    display: flex;\n    flex-grow: 2;\n    overflow: hidden;\n}\n\n.aiiif-splitter-horizontal {\n    flex-direction: column;\n    height: 100%;\n}\n\n.aiiif-splitter-container > div {\n    display: flex;\n    align-items: stretch;\n}\n\n.aiiif-splitter-container > div.aiiif-b {\n    flex-grow: 2;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
